/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [form-upload.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 26.02.20, 15:27
 */

import React, {useRef, useState} from 'react';
import {
    AddIcon,
    fs_bigger, fs_regular,
    SoundcloudBrandIcon,
    VimeoBrandIcon,
    YoutubeSquareIcon
} from "../navigation/icons/nav-icons";
import {RoundedButton} from "../navigation/buttons/nav-buttons";
import {useLanguage} from "../configuration/configuration";


const FormUpload = ({type, pattern, placeholder, callback}) => {
    const formRef = useRef();
    const [invalid, setInvalid] = useState(false);
    const Lang = useLanguage();

    const handleForm = (event) => {
        event.preventDefault();
        if (!event.target.checkValidity()) {
            setInvalid(true);
            return;
        }
        const data = new FormData(event.target);
        setInvalid(false);
        callback(data.get('url'), type);
        event.target.reset();
    }

    const getIcon = type => {
        switch(type) {
            case 'YOUTUBE': return <YoutubeSquareIcon size={fs_bigger}/>
            case 'VIMEO': return <VimeoBrandIcon size={fs_bigger}/>
            case 'SOUNDCLOUD': return <SoundcloudBrandIcon size={fs_bigger}/>
        }
    }

    return <form className={invalid ? 'form-invalid' : ''} ref={formRef}
                 noValidate
                 onSubmit={handleForm}>
        <div className="input-group media-upload-group">
            <div className="input-group-prepend">
                <span className="input-group-text">{getIcon(type)}</span>
            </div>
            <input type="text" name="url" className="form-control" autoComplete="off" required
                   placeholder={placeholder}
                   pattern={pattern}/>
            <RoundedButton title={Lang.post.editor.linkSubmit} onClick={() => formRef.current.click()}>
                <AddIcon size={fs_regular}/>
            </RoundedButton>
        </div>
    </form>
}

export default FormUpload;